import * as React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const CheckoutLink = ({
    style,
    label,
    page,
    horseForSaleIds,
    active,
    disabled,
    icon,
    onClick
}: {
    style?: string;
    label: React.ReactNode;
    page: string;
    horseForSaleIds: Array<number>;
    active: boolean;
    disabled?: boolean;
    icon?: React.ReactNode;
    onClick?: () => void;
}) => {
    const to = `/checkout/${horseForSaleIds.sort().join("+")}/${page}`;
    return (
        <li>
            <Link
                to={disabled ? {} : to}
                className={`nav-link-intern d-flex ${active ? "active" : ""} ${style ? style : ""} ${disabled ? "disabled" : ""}`}
                onClick={onClick}
                style={disabled ? { pointerEvents: "none" } : {}}
            >
                {label}
                {icon ? icon : <FontAwesomeIcon icon={faAngleRight} className={active ? "link-icon ml-auto my-auto" : ""} />}
            </Link>
        </li>
    );
};

export default CheckoutLink;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutLink.tsx